// src/config/build.ts

export const BUILD_ID = (() => {
  // Manually bump this when deploying
  return '2025-12-16T17:45Z-DELETE-AS-ANY';
})();
